import styled from "styled-components";

export const StyledEditor = styled.div`
  ${({ theme }) => `
    #editor, #preview {
      padding: 16px 0;
      font-family: ${theme.uptimeFonts.primary}, ${theme.uptimeFonts.secondary} !important;
    }

    .quill {
      margin-bottom: 16px;
      .ql-toolbar {
        background: #eaecec;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
      }
      .ql-snow {
        font-family: ${theme.uptimeFonts.primary}, ${theme.uptimeFonts.secondary} !important;
      }
      .ql-container {
        font-family: ${theme.uptimeFonts.primary}, ${theme.uptimeFonts.secondary} !important;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        background: #fefcfc;
        .ql-editor {
          min-height: 400px;
          font-size: 1rem;
        }
      }
    }
  `}
`;